module.exports = __webpack_public_path__ + "img/b8b0726b-0704-4881-b2df-bc9edb948fa1.191705b3.png";